import { ApiCall, ApiAuth } from "./api";
import {
  ICertificate,
  ICertificateFilterOptionsResponse,
  ICertificateParamsForLocation,
} from "./interface/certificate.interface";
import { TPremiseResponse } from "./interface/IDefaults";

export const getClientCertificates = async (guid_client: string): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate/list/${guid_client}`, ApiAuth()).get<ICertificate[]>();
};

export const getUserCertificates = async (
  guid_client: string,
  guid_user: string
): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate/list/${guid_client}/${guid_user}`, ApiAuth()).get<ICertificate[]>();
};

export const getCertificateFilterOptions = async (
  guid_client: string,
  certificateType: string = "0"
): Promise<TPremiseResponse<ICertificateFilterOptionsResponse>> => {
  return await new ApiCall(
    `/filter/${guid_client}/certificate/${certificateType}`,
    ApiAuth()
  ).get<ICertificateFilterOptionsResponse>();
};

export const getClientTaxCurrentAccountIntegrations = async (
  guid_client: string
): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate/list/${guid_client}/TAX_CURRENT_ACCOUNT`, ApiAuth()).get<ICertificate[]>();
};

export const getCertificates = async (): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate`, ApiAuth()).get<ICertificate[]>();
};

export const getCertificatesByClient = async (guid_client: string): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate/list/${guid_client}/ALL/side-by-side`, ApiAuth()).get<ICertificate[]>();
};

export const getCertificatesTaxCurrentAccount = async (): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate/TAX_CURRENT_ACCOUNT`, ApiAuth()).get<ICertificate[]>();
};

export const getCertificatesDte = async (): Promise<TPremiseResponse<ICertificate[]>> => {
  return await new ApiCall(`/certificate/DTE`, ApiAuth()).get<ICertificate[]>();
};

export const getParamsForLocation = async (
  guid_client: string,
  type: string
): Promise<TPremiseResponse<ICertificateParamsForLocation>> => {
  return await new ApiCall(
    `/certificate/params/${guid_client}/${type}`,
    ApiAuth()
  ).get<ICertificateParamsForLocation>();
};
